import React, { useEffect, useState } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router";
import BoxLayout from "../../../components/Common/BoxLayout/BoxLayout";
import DownloadIconBig from "../../../components/Common/SvgIcons/CommonIcons/DownloadIconBig";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { contentBulkUpload } from "../../../utils/mainTabs/manage/contentBulkUpload";
import Input from "../../../components/Common/Input/Input";
import { postCSVBulkUploadActionHandler } from "../../../store/actions/actionHandlers/manageActionHandler";
import classes from "./ContentBulkUpload.module.scss";
import loaders from "../../../store/actions/actionCreators/loadersActionCreator";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import { FormattedMessage } from "react-intl";

const ContentBulkUpload = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { tenantName } = useOutletContext();

  const methods = useForm({
    defaultValues: { BulkUploadCSV: {} },
  });
  const { reset } = methods;

  const manageState = useSelector((state) => state.manageReducer);
  const { addCSVBulkUploadLoader } = manageState;

  const [heading, setHeading] = useState("");
  const [sampleLink, setSampleLink] = useState("");
  const [fileTypeId, setFileTypeId] = useState(0);
  const [fileName, setFileName] = useState("");

  const tiles = contentBulkUpload.tiles(navigate, tenantName);
  const contentBulkUploadPath = contentBulkUpload.path(tenantName);

  useEffect(() => {
    if (location.pathname === contentBulkUploadPath) {
      navigate(`${contentBulkUploadPath}/shotclassDetails`);
    }
    tiles.forEach((tile) => {
      if (location.pathname === tile.path) {
        setHeading(tile.label);
        setSampleLink(tile.sampleLink);
        setFileTypeId(tile.fileType);
        setFileName(extractFileName(tile?.sampleLink)); 
      }
    });
  }, [location, navigate, tiles, contentBulkUploadPath]);

  const extractFileName = (downloadLink) => {
    if (!downloadLink) return '';
    const parts = downloadLink.split('/');
    const fileNameWithHash = parts.pop();
    const [fileName] = fileNameWithHash.split('.');
    return `${fileName}.csv`;
  };
  const handleBulkCSVUpload = (e) => {
    let file = e.target.files[0];
    if (file) {
      const acceptedTypes = ["text/csv"];
      if (!acceptedTypes.includes(file.type)) {
        dispatch(
          setErrorHandler(errorTypes.WARN, "Please select a valid format")
        );
      } else {
        dispatch(loaders.manage.contentBulkUpload.addCSVBulkUploadLoader(true));
        dispatch(postCSVBulkUploadActionHandler(fileTypeId, file)).then(
          (isUploaded) => {
            if (isUploaded) {
              dispatch(
                loaders.manage.contentBulkUpload.addCSVBulkUploadLoader(false)
              );
            }
          }
        );
      }
    }
    reset();
  };

  return (
    <BoxLayout
      height={location.pathname !== `${contentBulkUploadPath}/quizImages` && 42}
    >
      <div className={classes.contentBulkUpload}>
        <div className={classes.contentBulkUpload__heading}>{heading}</div>
        <div className={classes.contentBulkUpload__body}>
          {location.pathname === tiles[4].path ? (
            <Outlet />
          ) : (
            <div className={classes.contentBulkUpload__body__uploadContainer}>
              <a
                href={sampleLink}
                download={fileName}
                className={
                  classes.contentBulkUpload__body__uploadContainer__download
                }
              >
                <div
                  className={
                    classes.contentBulkUpload__body__uploadContainer__download__downloadIcon
                  }
                >
                  <DownloadIconBig />
                </div>
                <FormattedMessage id="BULKUPLD_CSVFILEDOWNLOAD" />
              </a>
              <FormProvider {...methods}>
                <Input
                  name="BulkUploadCSV"
                  type="file"
                  hidden={true}
                  onChange={handleBulkCSVUpload}
                  placeholder={<FormattedMessage id="UPLOAD_TEXT" />}
                  isLight={false}
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  loading={addCSVBulkUploadLoader}
                />
              </FormProvider>
              <div><FormattedMessage id="CSV_UPLOAD_NOTE" /></div>
            </div>
          )}
        </div>
      </div>
    </BoxLayout>
  );
};

export default ContentBulkUpload;
